module.exports = __webpack_public_path__ + "img/partypotus.a4f34033.gif";